import React, { Fragment } from "react";
import { Dropdown } from "primereact/dropdown";

const InputFieldDropdown = ({
  handler,
  variables: { value, disabled, showError },
  constants: { label, medSize, id, textError, name },
  options,
}) => {
  return (
    <Fragment>
      <div className={`p-field p-col-4 p-md-${medSize}`}>
        <label htmlFor={id}>{label}</label>
        <Dropdown
          name={name}
          id={id}
          value={value}
          options={options}
          onChange={handler}
          optionLabel='name'
          disabled={disabled}
          aria-describedby={`${id}-help`}
          // className={showError && "p-invalid p-d-block"}
        />
        {showError && (
          <small id={`${id}-help`} className='p-invalid p-d-block'>
            {textError}
          </small>
        )}
      </div>
    </Fragment>
  );
};

export default InputFieldDropdown;
